import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomerSignAgreementDialogComponent } from './customer-sign-agreement-dialog.component';
import { CustomerSignAgreementDialogService } from './customer-sign-agreement-dialog.service';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';

@NgModule({
  declarations: [CustomerSignAgreementDialogComponent],
  imports: [CommonModule, MatButtonModule, MatCheckboxModule],
  entryComponents: [CustomerSignAgreementDialogComponent],
  providers: [CustomerSignAgreementDialogService],
  exports: [CustomerSignAgreementDialogComponent],
})
export class CustomerSignAgreementDialogModule {}
